export function removeEndingNulls<Type>(array: (Type | null)[]): (Type | null)[] {
  return removeStartingNulls([...array].reverse()).reverse();
}

function removeStartingNulls<Type>(array: (Type | null)[]): (Type | null)[] {
  const [val, ...rest] = array;
  if (val === null) {
    return removeStartingNulls(rest);
  }
  return array;
}

export function range(start: number, end: number): number[] {
  return [...new Array(end - start).keys()]
    .map(value => value + start);
}

export function absoluteMaxValues(array: number[]): number {
  return Math.max(...array.map(value => Math.abs(value)));
}
